module.exports = __webpack_public_path__ + "static/media/matterport.49249fbc.png";